<template>
    <div class="d-flex align-items-center cursor-pointer" @click="onClick">
        <span class="text-primary">Kasy</span>
        <a-icon
            :icon="'Chevron'"
            :iconConfig="{ up: arrowUp, down: !arrowUp }"
        />
    </div>
</template>

<script>
import AIcon from '../../global/AIcon.vue'
export default {
    components: { AIcon },
    props: {
        onClick: {
            type: Function,
            default: () => {}
        },
        text: {
            type: String,
            default: ''
        },
        arrowUp: {
            type: Boolean,
            default: false
        }
    }
}
</script>
